import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=3d6e2bbe&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=3d6e2bbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6e2bbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d6e2bbe')) {
      api.createRecord('3d6e2bbe', component.options)
    } else {
      api.reload('3d6e2bbe', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=3d6e2bbe&scoped=true&", function () {
      api.rerender('3d6e2bbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wzB0OfmWKfbB/JS/teamMember.vue"
export default component.exports